// units.js — display-side unit helpers built on top of the pure math converters.
import { CONVERT } from "@/utils/ballisticsMath";

// Format a linear/angular drop or drift value into the selected holdover unit.
// dropM in metres, dropMrad in milliradians, moa in MOA.
export function formatHoldover(valM, valMrad, valMoa, unit) {
  switch (unit) {
    case "cm":
      return valM * 100;
    case "inch":
      return CONVERT.mToIn(valM);
    case "mrad":
      return valMrad;
    case "moa":
      return valMoa;
    default:
      return valM * 100;
  }
}

export const HOLDOVER_UNIT_LABEL = {
  cm: "CM",
  inch: "IN",
  mrad: "MRAD",
  moa: "MOA",
};

// Angular value (mrad) for a given sample, used for turret clicks & reticle.
export const CLICK_OPTIONS = [
  { id: "mrad-0.1", label: "1/10 MIL (0.1 MRAD)", mrad: 0.1 },
  { id: "moa-0.25", label: "1/4 MOA", mrad: 0.25 / CONVERT.MRAD_TO_MOA },
  { id: "moa-0.125", label: "1/8 MOA", mrad: 0.125 / CONVERT.MRAD_TO_MOA },
];

// Distance display in the active unit system.
export function distanceDisplay(m, system) {
  return system === "imperial" ? CONVERT.mToYd(m) : m;
}

export const UNIT_LABELS = {
  metric: { dist: "m", vel: "m/s", mass: "g", energy: "J", wind: "m/s", temp: "°C", scope: "cm" },
  imperial: { dist: "yd", vel: "fps", mass: "gr", energy: "ft-lbs", wind: "mph", temp: "°F", scope: "in" },
};

export function fmt(n, digits = 1) {
  if (n === null || n === undefined || Number.isNaN(n)) return "–";
  return n.toFixed(digits);
}
